/* eslint-disable react/prop-types */
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers"
import React, { forwardRef, useImperativeHandle, useState } from "react"
import { Grid } from "@material-ui/core"
import { useForm } from "react-hook-form"
import { has } from "lodash"
import StandardTextField from "components/common/input/StandardTextField"
import { purgeInitialFormData } from "utils/form-data"
import { USER_BLANK_FORMS } from "./const"

const schema = yup.object().shape({
  creator: yup.string().required("This field is required"),
})

const ReceiptOfInvoiceUserForm = forwardRef(({ defaultValue = {} }, ref) => {
  const [formData, setFormData] = useState(() =>
    purgeInitialFormData(defaultValue || {}, USER_BLANK_FORMS)
  )

  const { register, handleSubmit, errors, getValues } = useForm({
    resolver: yupResolver(schema),
    defaultValues: formData,
  })

  useImperativeHandle(
    ref,
    () => ({
      getFormData: () => {
        const currentFormData = getValues()
        const data = { ...formData, ...currentFormData }
        return { creator: data.creator ?? "" }
      },
      submitForm: () =>
        new Promise((res, rej) => {
          handleSubmit(res, rej)()
        }),
    }),
    [formData, getValues, handleSubmit]
  )

  const handleChange = (event) => {
    const { name, value } = event.target
    if (has(formData, name)) {
      const newFormData = { ...formData, [name]: value }
      setFormData(newFormData)
    }
  }

  const settings = {
    onChange: handleChange,
    fullWidth: true,
    margin: "dense",
  }

  return (
    <Grid item xs={12} md={6}>
      <StandardTextField
        label="Dibuat Oleh"
        {...settings}
        name="creator"
        inputRef={register({ required: "This field is required" })}
        error={!!errors.creator}
        helperText={errors?.creator?.message}
        InputLabelProps={{
          shrink: true,
        }}
        defaultValue={formData?.creator ?? ""}
      />
    </Grid>
  )
})

export default ReceiptOfInvoiceUserForm
